/* global axios */

import ApiClient from './ApiClient';

class ScheduledMessagesAPI extends ApiClient {
  constructor() {
    super('scheduled_messages', { accountScoped: true });
  }

  conversationUrl(conversationId) {
    return `${this.baseUrl()}/conversations/${conversationId}/scheduled_messages`;
  }

  get(conversationId) {
    return axios.get(this.conversationUrl(conversationId));
  }

  create(conversationId, data) {
    return axios.post(this.conversationUrl(conversationId), data);
  }

  update(conversationId, id, data) {
    return axios.patch(`${this.conversationUrl(conversationId)}/${id}`, data);
  }

  delete(conversationId, id) {
    return axios.delete(`${this.conversationUrl(conversationId)}/${id}`);
  }

  sendNow(conversationId, id) {
    return axios.post(`${this.conversationUrl(conversationId)}/${id}/send_now`);
  }

  pause(conversationId, id) {
    return axios.post(`${this.conversationUrl(conversationId)}/${id}/pause`);
  }

  resume(conversationId, id, scheduledAt) {
    return axios.post(`${this.conversationUrl(conversationId)}/${id}/resume`, {
      scheduled_at: scheduledAt,
    });
  }
}

export default new ScheduledMessagesAPI();
